import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/hair-loss-blog/category/$slug")({
  // Archives redirect to the blog index (ARCHIVE in legacy-path-redirects.ts).
  beforeLoad: () => {
    throw redirect({ href: "/hair-loss-blog/", statusCode: 301 });
  },
});
